import { useEffect } from 'react';
import { CurrentRoute } from './router';
import { PublicLayout } from '../public/PublicLayout';
import { applyMetadata } from './seo';

export function App() {
  useEffect(() => applyMetadata(window.location.pathname), []);
  const content = <CurrentRoute />;

  if (window.location.pathname.startsWith('/admin')) {
    return content;
  }

  return <PublicLayout>{content}</PublicLayout>;
}
